import React from 'react';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from './Dialog/Dialog';
import RangeDatePicker from '../fields/RangeDatePicker/RangeDatePicker';
import { Button, Icons } from './BootstrapComponents/BootstrapComponents';
import FieldDTO from '../fields/Abstract/FieldDTO';
import { createClearObject } from '../../utils/utils';
import CalendarDatePicker from '../fields/RangeDatePicker/CalendarDatePicker';
import DateTimePicker from '../fields/DatePicker/DateTimePicker';

export default function MobileIntervalModal(props) {
  const {
    control,
    defaultValues,
    reset = () => {},
    handleClose = () => {},
    getValues = () => {},
    setValue = () => {},
  } = props;

  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };

  const getDateValue = index => {
    const v = getValues('vehicle_datetime_at');
    if (v && v.length && v[index]) {
      return v[index];
    }
    return Date.now();
  };

  return (
    <Dialog
      className="mobile-search-modal mobile-period-modal"
      onClose={() => { handleClose(); }}
      size="xl"
      open
    >
      <DialogContent className="msm-content">
        <div className="msm-header">
          <div className="title-text">Период</div>
          <div className="close-wrapper">
            <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={handleClose} />
          </div>
        </div>
        <div className="interval-wrapper">
          <FieldDTO
            control={control}
            component={DateTimePicker}
            dtoObject={{
              name: 'vehicle_datetime_at',
              type: String,
              labelKey: 'event.date',
            }}
            usePortal
            hideClose
            placeholder="Дата события с"
            label="Дата события с"
            changeFormat="YYYY-MM-DDTHH:mm:ss"
            inputProps={{
              onChange: e => { setValue('vehicle_datetime_at', [e.target.value || '', getDateValue(1)]); },
              value: getDateValue(0),
            }}
            withLabel
          />
          <FieldDTO
            control={control}
            component={DateTimePicker}
            dtoObject={{
              name: 'vehicle_datetime_at',
              type: String,
              labelKey: 'event.date',
            }}
            withLabel
            usePortal
            hideClose
            placeholder="Дата события по"
            label="Дата события по"
            changeFormat="YYYY-MM-DDTHH:mm:ss"
            inputProps={{
              onChange: e => { setValue('vehicle_datetime_at', [getDateValue(0), e.target.value || '']); },
              value: getDateValue(1),
            }}
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={CalendarDatePicker} */}
          {/*  dtoObject={{ */}
          {/*    name: 'created_at', */}
          {/*    type: String, */}
          {/*    validators: {}, */}
          {/*    labelKey: 'application.created_at', */}
          {/*  }} */}
          {/*  usePortal */}
          {/*  placeholder="Дата подачи" */}
          {/*  changeFormat="YYYY-MM-DD" */}
          {/*  className="no-border" */}
          {/* /> */}
        </div>
      </DialogContent>
      <DialogFooter className="msm-footer">
        <Button variant="secondary" onClick={clear}>Сбросить</Button>
        <Button onClick={handleClose}>Найти</Button>
      </DialogFooter>
    </Dialog>
  );
}
